// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CreatedShareableBusinessCardRow,
} from "./types";

export const params = {
  underwritableEntity: __t.uuid(),
  accessCode: __t.option(__t.string()),
};
export const returnType = CreatedShareableBusinessCardRow